
const isSourceDeletable = (source) => !source?.trackers?.length

export default isSourceDeletable;